import axios from 'axios';

// Configure axios to include credentials
axios.defaults.withCredentials = true;

// Use the proxy instead of the full URL
const API_URL = '/api';

/**
 * Get a secondary contact from HubSpot using a specified property relationship
 * @param {string} contactId - Primary contact ID
 * @param {string} propertyName - Property name to check for relationship
 * @returns {Promise<Object>} - Secondary contact data
 */
export const getSecondaryContactByProperty = async (contactId, propertyName) => {
  try {
    console.log(`Fetching secondary contact for ${contactId} using property ${propertyName}`);
    const response = await axios.get(`${API_URL}/hubspot/contacts/${contactId}/secondary/${propertyName}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching secondary contact by property:', error);
    
    // If no secondary contact found (404), don't treat as error, just return null
    if (error.response && error.response.status === 404) {
      return null;
    }
    
    throw error;
  }
}; 